import React from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import { toaster } from 'evergreen-ui';
import { isAdminSelector } from 'Services/auth.service';
import { SETTINGS_PATHS } from 'Features/routePaths';

const CodesRouter = React.lazy(() => import('./Common.Codes/Codes.Router'));
const Descriptors = React.lazy(() => import('./Common.Parameters/Parameters.Router'));
const DescriptorTypes = React.lazy(() => import('./Common.DescriptorTypes'));
// const DescriptorValuesRouter = React.lazy(() => import('./Common.DescriptorValues'));
const CodeDescriptor = React.lazy(() => import('./Common.CodeDescriptor'));
const StationCats = React.lazy(() => import('./Common.StationCats'));
const StationTypesRouter = React.lazy(() => import('./Common.StationTypes'));
const EntityTypesRouter = React.lazy(() => import('./Common.EntityTypes'));
const RegionsRouter = React.lazy(() => import('./Common.Regions'));
const RegionTypes = React.lazy(() => import('./Common.RegionTypes'));
const VocUnitsRouter = React.lazy(() => import('./Common.VocUnits'));
const DatasourceTypesRouter = React.lazy(() => import('./Common.DatasourceTypes'));
const DatasourceSebaMappingRouter = React.lazy(() => import('./Common.DataSourceSebaMapping'));
const VocStatusesRouter = React.lazy(() => import('./Common.VocStatuses'));
const VocModesRouter = React.lazy(() => import('./Common.VocModes'));
const ProgramTypesRouter = React.lazy(() => import('./Common.ProgramTypes'));
const TelegramTypesRouter = React.lazy(() => import('./Common.TelegramKeys'));
const TelegramTypesAndKeysRouter = React.lazy(() => import('./Common.TelegramTypes/Router.TelegramTypesAndKeys'));
const Channels = React.lazy(() => import('./Common.Channels/ChannelsRouter'));
const ChannelTypes = React.lazy(() => import('./Common.ChannelTypes/ChannelTypesRouter'));
const ObservingProgramsRoutes = React.lazy(() => import('./Common.ObservingPrograms/ObservingProgramsRouter.tsx'));
const Microservices = React.lazy(() => import('./Common.Microservices'));
const NotificationTypes = React.lazy(() => import('./Common.NotificationTypes'));
const NotificationEventTypes = React.lazy(() => import('./Common.NotificationEventTypes'));
const NotificationRoleMasks = React.lazy(() => import('./Common.RoleMasks'));
const NotificationRoleMasksToNotificationEventType = React.lazy(() => import('./Common.RoleMasks.To.NotificationEventType/RoleMasksToEventTypeRouter'));
const HostControll = React.lazy(() => import('./Common.HostControll'));
const MeteoCodes = React.lazy(() => import('./Common.Meteocodes/Router'));
const VocSampleTypes = React.lazy(() => import('./Common.VocSampleTypes'));
const DeviceTypesRouter = React.lazy(() => import('./Common.DeviceTypes'));
const CronExpressionRouter = React.lazy(() => import('./Common.CronExpression.tsx'));
const HModelsRouter = React.lazy(() => import('./Common.HModels/Router.HModels'));

export default function SettingsCommonRouter() {
  const isAdmin = useSelector(isAdminSelector);
  React.useEffect(() => {
    if (!isAdmin) toaster.warning('Нет прав для просмотра настроек!');
  }, [isAdmin]);

  if (!isAdmin) return <Navigate to="/" />;
  return (
    <Routes>
      <Route index path="/" element={<Navigate to="channels" replace />} />
      <Route path="codes/*" element={<CodesRouter />} />
      <Route path="meteo-codes/*" element={<MeteoCodes />} />
      <Route path="descriptors/*" element={<Descriptors />} />
      <Route path="code-descriptors" element={<CodeDescriptor />} />
      {/** descriptor-types = нет форм для создания */}
      <Route path="descriptor-types" element={<DescriptorTypes />} />
      {/* Редактирование / создание значений для параметров перенесено в таблицу с параметрами (Description) */}
      {/* <Route path="descriptor-values/*" element={<DescriptorValuesRouter />} /> */}
      <Route path="station-cats/*" element={<StationCats />} />
      <Route path="station-types/*" element={<StationTypesRouter />} />
      <Route path="entity-types/*" element={<EntityTypesRouter />} />

      {/** regions и region-types = нет форм для создания */}
      <Route path="regions/*" element={<RegionsRouter />} />
      <Route path="region-types" element={<RegionTypes />} />

      <Route path="datasource-type/*" element={<DatasourceTypesRouter />} />
      <Route path="datasource-seba-mapping-settings/*" element={<DatasourceSebaMappingRouter />} />
      <Route path="vocmodes/*" element={<VocModesRouter />} />
      <Route path="datasource-statuses/*" element={<VocStatusesRouter />} />
      <Route path="sample-types/*" element={<VocSampleTypes />} />

      <Route path="observing-programs/*" element={<ObservingProgramsRoutes />} />
      <Route path="device-types/*" element={<DeviceTypesRouter />} />

      <Route path="program-type/*" element={<ProgramTypesRouter />} />

      <Route path="voc-units/*" element={<VocUnitsRouter />} />
      <Route path="settings-cron-expression/*" element={<CronExpressionRouter />} />

      <Route path="telegram-keys/*" element={<TelegramTypesRouter />} />
      <Route path={`${SETTINGS_PATHS.telegramType}/*`} element={<TelegramTypesAndKeysRouter />} />

      <Route path="channels/*" element={<Channels />} />
      <Route path="channel-types/*" element={<ChannelTypes />} />
      <Route path="microservices/*" element={<Microservices />} />

      <Route path="notification-types/*" element={<NotificationTypes />} />
      <Route path="notification-event-types/*" element={<NotificationEventTypes />} />
      <Route path="notification-event-type-role-masks/*" element={<NotificationRoleMasks />} />
      <Route path="notification-event-type-to-role-masks/*" element={<NotificationRoleMasksToNotificationEventType />} />

      <Route path="host-controll/*" element={<HostControll />} />

      <Route path={`${SETTINGS_PATHS.hModels}/*`} element={<HModelsRouter />} />

      <Route path="*" element={<Navigate to="codes" replace />} />
    </Routes>
  );
}
